//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Work } from "@/models";
import { throws } from "assert";
import filters from "@/filters";
import WorkAudioPostItem from "@/components/post_item/WorkAudioPostItem.vue";
import More from "@/components/More.vue";
import { mapGetters } from "vuex";
import WorkBottomBar from "@/components/bottom_bar/WorkBottomBar.vue";

let markdown = filters.markdown;
let highlightKeyAndMarkdown = filters.highlightKeyAndMarkdown;

export default {
  name: "Work",
  created() {
    let id = this.$route.params.id;
    if (!id) {
      return;
    }
    this.workId = id;
    let promises = [];

    Work.getById(id).then((work) => {
      this.work = work;

      // 如果用户存在，检查是否收藏本work
      if (this.user) {
        this.checkLike();
      }

      this.generateKeysAndValues(work);
      this.$initWechat().then(() => {
        this.$initWechatShare({
          title: this.title,
          link: location.href,
          // image: "http://ac-9pq709je.clouddn.com/bda4f64984c2dba80105.png",
          image: "http://bigfile.xichuangzhu.com/logo.png",
          // desc: "品味中国诗词之美"
          desc: this.description,
        });
      });
    });

    // Promise.all(promises).then(() => {
    //   this.work.liked = this.liked

    //   this.$store.commit('setCurrentWork', this.work)
    // })

    Work.getSelectedAudios(id).then((posts) => {
      this.audioPosts = posts;
    });
  },
  props: [],
  data() {
    return {
      liked: false,
      workId: null,
      work: null,
      keys: [],
      values: [],
      currentIndex: 0,
      audioPosts: [],
    };
  },
  metaInfo() {
    return {
      title: this.title,
      titleTemplate: null,
    };
  },
  computed: {
    ...mapGetters(["user"]),
    title: function () {
      return this.work ? this.work.get("title") + " · 西窗烛" : "西窗烛";
    },
    contentHTML: function () {
      return this.work ? markdown(this.work.get("content")) : null;
    },
    description: function () {
      return this.work
        ? this.work.get("content").split("\n")[0]
        : "品味中国诗词之美";
    },
  },
  methods: {
    // 检查Like
    checkLike: function () {
      Work.checkLike(this.work.id).then(({ liked }) => {
        this.liked = liked;
      });
    },
    toggleLiked: function () {
      this.liked = !this.liked;
    },
    goToWorkPost: function () {
      this.$router.push({
        name: "workPost",
        params: {
          workId: this.work.id,
          workName: this.work.get("title"),
        },
      });
    },
    switchValue: function (index) {
      this.currentIndex = index;
    },
    goToAuthor: function () {
      this.$router.push({
        name: "author",
        params: {
          id: this.work.get("author").id,
        },
      });
    },
    goToWorkLists: function () {
      this.$router.push({
        name: "workLists",
        params: {
          id: this.work.id,
        },
      });
    },
    generateKeysAndValues: function (work) {
      if (work.get("intro")) {
        this.keys.push("评析");
        this.values.push(markdown(work.get("intro")));
      }
      if (work.get("annotation")) {
        this.keys.push("注释");
        this.values.push(highlightKeyAndMarkdown(work.get("annotation")));
      }
      if (work.get("translation")) {
        this.keys.push("译文");
        this.values.push(markdown(work.get("translation")));
      }
      // TODO: 先隐藏掉
      // if (work.get("appreciation")) {
      //   this.keys.push("赏析");
      //   this.values.push(markdown(work.get("appreciation")));
      // }
      if (work.get("masterComment")) {
        this.keys.push("辑评");
        this.values.push(highlightKeyAndMarkdown(work.get("masterComment")));
      }
    },
  },
  components: {
    WorkAudioPostItem,
    More,
    WorkBottomBar,
  },
};



// WEBPACK FOOTER //
// ./src/pages/library/Work.vue